import { FC } from 'react';
import { useDispatch } from 'react-redux';

import { toast } from 'sonner';
import { BaseModal } from 'wbs-components-lib';

import { useUpdateTicketByIdMutation } from '@services';

import { AppDispatch, updateTicket } from '@store';

import { TicketSettingsForm, TicketSettingsFormValues } from '../TicketSettingsForm';

import { TicketSettingsEditModalProps } from './types';
import { getTicketEditFormValuesFromModel } from './utils';

export const TicketSettingsEditModal: FC<TicketSettingsEditModalProps> = ({ ticket, handleClose, isOpened }) => {
  const dispatch = useDispatch<AppDispatch>();

  const [updateTicketById, { isLoading: isTicketUpdating }] = useUpdateTicketByIdMutation();

  const { id: ticketId } = ticket;

  const handleEditTicket = async ({ date, ...formValues }: TicketSettingsFormValues) => {
    const updatedTicket = await updateTicketById({
      ticketId,
      payload: { ...formValues, date: date.format() },
    }).unwrap();

    dispatch(updateTicket(updatedTicket));

    toast.success('Ticket has been updated successfully!');

    handleClose();
  };

  const initialFormValues = getTicketEditFormValuesFromModel(ticket);

  return (
    <BaseModal headerTitle="Edit Ticket" isOpened={isOpened} handleClose={handleClose} isFooterNeeded={false}>
      <TicketSettingsForm
        initialValues={initialFormValues}
        submitButtonCaption="Edit"
        isSubmitting={isTicketUpdating}
        onSubmit={handleEditTicket}
      />
    </BaseModal>
  );
};
